import React, { useState } from "react";
import "./OurPrograms.css";

// images 
import Civil from "../../assets/images/Departments-pics/CIVIL-1-1.jpg"
import mech from "../../assets/images/Departments-pics/MECH.jpg"
import EEE from "../../assets/images/Departments-pics/EEE-3.jpg"
import Cec from "../../assets/images/Departments-pics/ECE.jpg"
import It from "../../assets/images/Departments-pics/EEE.jpg"
import Ai from "../../assets/images/Departments-pics/AI-and-ML.jpg"
import Cse from "../../assets/images/Departments-pics/IT.jpg"

const programsData = [
  { id: 1, type: "Btech", title: "Civil Engineering", img: Civil },
  { id: 2, type: "Mtech", title: "Mechanical Engineering", img: mech },
  { id: 3, type: "Btech", title: "Electrical and Electronics Engineering", img: EEE },
  { id: 4, type: "Btech", title: "Electronics and Communication Engineering", img: Cec },
  { id: 5, type: "Mtech", title: "Information Technology", img: It },
  { id: 6, type: "Mtech", title: "AI stands for Artificial Intelligence and ML stands for Machine Learning", img: Ai },
  { id: 7, type: "Btech", title: "Computer Science and Engineering", img: Cse },
];

const tabs = ["All Programs", "Bachelor of Engineering", "Master of Engineering"];

const OurPrograms = () => {
  const [activeTab, setActiveTab] = useState("All Programs");

  const filteredPrograms =
    activeTab === "All Programs"
      ? programsData
      : activeTab === "Bachelor of Engineering"
      ? programsData.filter((p) => p.type === "Btech")
      : programsData.filter((p) => p.type === "Mtech");

  return (
    <div
      className="container OurPrograms-section"
      data-aos="fade-up"
      data-aos-delay="100"
    >
      <div className="row">
        <div className="col-lg-12">
          <div className="title-box">
            <h2>Our Programs</h2>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Program Cards */}
      <div className="programs-grid">
        {filteredPrograms.map((program) => (
          <div className="program-card" key={program.id}>
            <img src={program.img} alt={program.title} className="img-fluid" />
            <h3>{program.type}</h3>
            <p>{program.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurPrograms;
